/**
 * The one shared report-running endpoint every report screen goes through — Part F's "reports
 * share one filter, one pagination, one export layer" instruction, applied on the frontend side
 * of the same shell the server's `ReportFilter`/`ReportExporter` already give every handler.
 * <p>
 * Deliberately untyped on the response: thirty-five reports return thirty-five different row
 * shapes, and typing each individually here would duplicate the C# response records rather than
 * share a shell with them. A report screen reads the fields it knows it asked for.
 */

import { api } from '../api.js';

export type ReportRunParams = Readonly<Record<string, string | number | boolean | undefined>>;

export const reportApi = api.injectEndpoints({
  endpoints: (build) => ({
    runReport: build.query<unknown, { path: string; params?: ReportRunParams | undefined }>({
      query: ({ path, params }) => ({ url: path, params: params ?? {} }),
      // Every report is a fresh read against a filter the user just chose — nothing here is
      // worth caching between two different filter combinations under one tag.
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useRunReportQuery } = reportApi;
